export const FOTOGRAFIAS_ADD_PHOTO = 'FOTOGRAFIAS@ADD_PHOTO';
export const FOTOGRAFIAS_DELETE_PHOTO = 'FOTOGRAFIAS@DELETE_PHOTO';
export const FOTOGRAFIAS_UPLOAD_PHOTOS = 'FOTOGRAFIAS@UPLOAD_PHOTOS';
export const FOTOGRAFIAS_STOP_UPLOAD = 'FOTOGRAFIAS@STOP_UPLOAD';
export const FOTOGRAFIAS_SET_CURRENT_PHOTO = 'FOTOGRAFIAS@SET_CURRENT_PHOTO';
export const FOTOGRAFIAS_SET_RECURSOS_PHOTO = 'FOTOGRAFIAS_SET_RECURSOS_PHOTO';
